import { useEffect, useState } from 'react'
import '@/style/contact.scss'
import PageHero from '@/components/PageHero'
import Reveal from '@/components/Reveal'
import AmapView from './amapView'
import heroImg from '@/images/site/hero-contact.jpg'

const ADDRESSES = [
  {
    title: '河北保定',
    address: '河北省保定市涿州市高官庄镇解家楼村村北',
    tel: '139 1110 2112',
    email: '120299424@qq.com',
    geo: [116.03669, 39.383585],
  },
]

function Contact() {
  const [activeIndex, setActiveIndex] = useState(0)

  useEffect(() => {
    const type = new URLSearchParams(window.location.search).get('type')
    if (!type) return
    document.getElementById(type)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [])

  return (
    <>
      <PageHero
        eyebrow="Contact"
        title="联系我们"
        image={heroImg}
      />

      <section className="section contact__section" id="contactUs">
        <div className="mainContent">
          <Reveal className="secHead">
            <p className="secHead__eyebrow">Get in touch</p>
            <h2 className="secHead__title">联系方式</h2>
          </Reveal>

          <div className="contact__grid">
            <div className="contact__left">
              {ADDRESSES.map((item, i) => (
                <Reveal key={item.title} delay={i * 90}>
                  <div
                    className={['contactCard', activeIndex === i ? 'is-active' : ''].join(' ')}
                    onMouseEnter={() => setActiveIndex(i)}
                    onFocus={() => setActiveIndex(i)}
                  >
                    <h3 className="contactCard__title">
                      <span className="contactCard__dot" aria-hidden="true" />
                      {item.title}
                    </h3>
                    <dl className="contactCard__list">
                      <div>
                        <dt>办公地址</dt>
                        <dd>{item.address}</dd>
                      </div>
                      <div>
                        <dt>联系电话</dt>
                        <dd>
                          <a href={`tel:${item.tel.replace(/\s/g, '')}`}>{item.tel}</a>
                        </dd>
                      </div>
                      <div>
                        <dt>电子邮箱</dt>
                        <dd>
                          <a href={`mailto:${item.email}`}>{item.email}</a>
                        </dd>
                      </div>
                    </dl>
                  </div>
                </Reveal>
))}

              </div>

            <Reveal className="contact__mapWrap" delay={140}>
              <div className="contact__map">
                <AmapView />
              </div>
              <p className="contact__mapHint">滚轮缩放 · 拖拽平移</p>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  )
}

export default Contact